import * as React from 'react';

import {Button} from '../button/button';
import {Label} from '../form/label';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {Popover} from '../popover/popover';
import {SelectPickerGeneric} from '../select-picker-generic/select-picker-generic';
import {TextField} from '../textfield/textfield';
import {Body} from '../typography/body';

type FallbackConfig = {
    defaultValue: string;
    description: string | React.ReactNode;
};

export type MergeField = {
    value: string;
    label: string;
    description?: string | React.ReactNode;
    fallbackText: FallbackConfig | null | undefined;
};

type Props = {
    onAddMergeField: (value: string, fallbackText?: string | null | undefined) => void;
    options: MergeField[];
};

export function MergeFieldsButton(props: Props) {
    const [isAddingMergeField, setIsAddingMergeField] = React.useState<boolean>(false);
    const [selectedMergeField, setSelectedMergeField] = React.useState<
        MergeField | null | undefined
    >(null);
    const [fallbackText, setFallbackText] = React.useState<string | null | undefined>(null);
    const buttonRef = React.useRef(null);

    React.useEffect(() => {
        if (selectedMergeField && selectedMergeField.fallbackText) {
            setFallbackText(selectedMergeField.fallbackText.defaultValue || '');
        }
    }, [selectedMergeField]);

    const handleAddMergeField = () => {
        if (selectedMergeField) {
            props.onAddMergeField(selectedMergeField.value, fallbackText);
        }

        setSelectedMergeField(null);
        setFallbackText(null);
        setIsAddingMergeField(false);
    };

    return (
        <>
            <Button
                onClick={() => setIsAddingMergeField(!isAddingMergeField)}
                getButtonRef={buttonRef}
            >
                Insert merge field
            </Button>
            {isAddingMergeField && (
                <Popover
                    anchor={buttonRef.current}
                    location='left'
                    onBlur={() => setIsAddingMergeField(false)}
                    // @ts-expect-error
                    onClose={() => setIsAddingMergeField(false)}
                >
                    <div className='pad-16' style={{width: '300px'}}>
                        <StackLegacy spacing={16}>
                            <Body size='large' isBold={true}>
                                Add a merge field
                            </Body>
                            <StackLegacy spacing={4}>
                                <SelectPickerGeneric
                                    options={props.options}
                                    value={selectedMergeField}
                                    // @ts-expect-error
                                    onChange={(val) => setSelectedMergeField(val)}
                                />
                                {selectedMergeField && selectedMergeField.description}
                            </StackLegacy>
                            {selectedMergeField && selectedMergeField.fallbackText ? (
                                <>
                                    {/* @ts-expect-error */}
                                    <Label isRequired={true} htmlFor='fallbackText'>
                                        Fallback text
                                    </Label>
                                    <StackLegacy spacing={4}>
                                        <TextField
                                            key={selectedMergeField.value}
                                            // @ts-expect-error
                                            name='fallbackText'
                                            value={fallbackText || ''}
                                            focusOnMount={true}
                                            onChange={(val) => setFallbackText(val)}
                                            placeholder='ex. friend'
                                        />
                                        {selectedMergeField.fallbackText.description}
                                    </StackLegacy>
                                </>
                            ) : null}
                            <div className='flex justify-sb'>
                                <Button
                                    variant='text-secondary'
                                    onClick={() => setIsAddingMergeField(false)}
                                    noPadding={true}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant='save'
                                    onClick={handleAddMergeField}
                                    disabled={Boolean(
                                        !selectedMergeField ||
                                            (selectedMergeField.fallbackText && !fallbackText)
                                    )}
                                >
                                    Add
                                </Button>
                            </div>
                        </StackLegacy>
                    </div>
                </Popover>
            )}
        </>
    );
}
